import baseService from "../services/BaseService";

export const getAllBrands = async () => baseService.get("brands");
export const getBrandByCategoryId = async (id) =>
  baseService.get(`brands/serviceCategoryId/${id}`);
